import { DynamicContent } from '../../../utils/DynamicContent';
import FormHeading from '../../../sharedComponents/FormHeading';

type PropsT = {
    id: string;
    node: string;
    heading?: string;
    description?: string;
};

const BladeFormHeading = ({
    id, node, heading, description,
}: PropsT) => (
    <>
        <FormHeading id={`${id}-${node}-form-heading`}>{heading}</FormHeading>
        <p id={`${id}-${node}-form-description`} className="mb-4 mb-md-3">
            <DynamicContent content={description} id={id} />
        </p>
    </>
);

export default BladeFormHeading;
